import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import SubjectCountBox from "../OfflinePerformance/SubjectCountBox/SubjectCountBox";
import FilterBox from "../../Homework/pages/On_going/Published_Assessment/Filter_Box/FilterBox";
import OfflineCompletedBox from "../OfflinePerformance/OfflineCompletedAssessBox/OfflineCompletedBox";
import DraftCompetencyPage from "./draftCompetencyPage";
import CompletedCompetencyPage from "./completedCompetencyPage";

function CompetencyPage({ leftSidebarSize }) {
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON = JSON.parse(general_role);

  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON = JSON.parse(classTeacher);

  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON = JSON.parse(cordinator);
  const storedHeader = localStorage.getItem("clickedHeader");
  const [activeHeader, setActiveHeader] = useState(
    storedHeader === "" || storedHeader === null ? "Draft" : storedHeader,
  );

  const buttons = localStorage.getItem("buttons");
  localStorage.setItem("buttons", buttons);
  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    searchvalue: "",
    standard_id: "",
    section_id: "",
  });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);

  // useClickOutside(popupRef, () => setIsPopupOpen(false));

  const handlePopupClick = (event) => {
    event.stopPropagation();
    setIsPopupOpen(!isPopupOpen);
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  dropDownHelper();
  handleDropDownSec();

  useEffect(() => {
    setActiveHeader("Draft");
  }, []);

  return (
    <div className="d-flex flex-column h-100  gap-1">
      <div
        className=" h-100 rounded-3 p-2 "
        style={{ backgroundColor: "white" }}
      >
        {/* <div
          className={`   ${leftSidebarSize === 70 ? "expand" : "collapasess"}`}
        >
          <SubjectCountBox from="competency" filter={filter} />
        </div> */}
        <div className="mt-2 me-3 main_button_box">
          <div className="col-md- m-0 p-0 d-flex align-items-center justify-content-between main_button_box1">
            <button
              className={`poppins-semibold ${
                activeHeader === "Draft"
                  ? "active main_three_button_active orange-text poppins-semibold "
                  : "main_three_button "
              }`}
              onClick={(e) => {
                setActiveHeader("Draft");
                localStorage.setItem("clickedHeader", "Draft");
              }}
              style={{ width: "150px" }}
            >
              Draft
            </button>
            <button
              className={`poppins-semibold ${
                activeHeader === "Completed"
                  ? "active main_three_button_active orange-text poppins-semibold "
                  : "main_three_button "
              }`}
              onClick={(e) => {
                setActiveHeader("Completed");
                localStorage.setItem("clickedHeader", "Completed");
              }}
              style={{ width: "150px" }}
            >
              Completed
            </button>
          </div>
          <div className="col-xl-6 col-lg-5 col-md-7 p-0 d-flex align-items-center justify-content-between tablet-layout">
            <div className="col-12 col-md-6 p-0  tab-margin">
              <input
                className="form-control mr-sm-2 m-0 name_search_box tab-margin"
                type="search"
                placeholder="Search by Name"
                maxLength={50}
                aria-label="Search"
                onChange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    searchvalue: e.target.value,
                  }))
                }
              ></input>
              <img
                className="name_search_icon"
                src="/images/search icon.svg"
                alt=""
              />
            </div>
            {/* <Popup
              on="click"
              className="popup_filter_box"
              style={{ zIndex: "999" }}
              open={isPopupOpen}
              onOpen={togglePopup}
              onClose={togglePopup}
              trigger={
                <div
                  className="col-md-2 col-12 gap-2  filter_button tab-margin"
                  onClick={handlePopupClick}
                >
                  <img
                    src="/images/filter_icon.svg"
                    alt=""
                    onClick={handlePopupClick}
                  />
                  <span>Filter</span>
                </div>
              }
              content={
                <div ref={popupRef}>
                  <FilterBox
                    setFilter={setFilter}
                    filter={filter}
                    setIsPopupOpen={setIsPopupOpen}
                    togglePopup={togglePopup}
                  />
                </div>
              }
              position="bottom center"
            /> */}

            <Link to="/add-competency" className="link">
              <div
                className=" col-md-3 col-12 gap-2  add_button tab-margin"
                onClick={() => {
                  localStorage.setItem("ActiveBtn", "");
                }}
              >
                <img src="/images/add icon.svg" alt="" />
                <span>Add Competency</span>
              </div>
            </Link>
          </div>
        </div>

        <div className="me-3 d-flex justify-content-end">
          <div className="m-0 mt-1 p-0 gap-2 mt-3 d-flex align-items-center">
            <FormControl size="small" sx={{ minWidth: 150, ml: 2 }}>
              <InputLabel>Select Class</InputLabel>
              <Select
                value={filter.standard_id}
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    standard_id: e.target.value,
                    section_id: "",
                  })
                }
                label="Select Class"
              >
                <MenuItem value="">Select All</MenuItem>
                {standardArr?.length > 0 &&
                  [...standardArr]
                    .sort((a, b) => {
                      const aNum = Number(a.name);
                      const bNum = Number(b.name);

                      const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                      if (bothNumeric) {
                        return aNum - bNum; // numeric sort
                      }

                      return a.name.localeCompare(b.name); // alphabetical sort
                    })
                    .map((standard, index) => (
                      <MenuItem
                        key={index}
                        value={standard?.id}
                        name={standard?.name}
                      >
                        {standard?.name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>

            <FormControl
              size="small"
              sx={{ minWidth: 150, ml: 2 }}
              disabled={!filter.standard_id}
            >
              <InputLabel>Select Section</InputLabel>
              <Select
                value={filter.section_id}
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    section_id: e.target.value,
                  })
                }
                label="Select Section"
              >
                <MenuItem value="">Select All</MenuItem>
                {sectionArr
                  ?.slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
        </div>
        {/* ////below css comes in published_hw.css////// */}
        <div
          className="mt-3 w-100 me-3 button_box_conatainer orange-scrollBar"
          style={{
            maxHeight: "280px",
            overflowY: "scroll",
            paddingTop: "1em",
            paddingBottom: "1em",
          }}
        >
          {activeHeader === "Completed" && (
            <CompletedCompetencyPage filter={filter} />
          )}
          {activeHeader === "Draft" && (
            <DraftCompetencyPage filter={filter} setFilter={setFilter} />
          )}
        </div>
      </div>
    </div>
  );
}

export default CompetencyPage;
